import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fade from 'react-reveal/Fade';

import { ThemeContext } from '../../contexts/ThemeContext';
import eduImgBlack from '../../assets/svg/education/eduImgBlack.svg';
import eduImgWhite from '../../assets/svg/education/eduImgWhite.svg';
import './Education.css';

// makeStyles কে কম্পোনেন্টের বাইরে নিয়ে আসা হলো পারফরম্যান্স বুস্ট করার জন্য
const useStyles = makeStyles((t) => ({
    educationCard: {
        backgroundColor: ({ theme }) => theme.quaternary,
        transition: 'background-color 0.2s ease-in-out', // হোভার স্মুথ করার জন্য ট্রানজিশন
        "&:hover": {
            backgroundColor: ({ theme }) => theme.primary50,
        },
    },
}));

function EducationCard({ id, institution, course, startYear, endYear }) {
    const { theme } = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <Fade bottom>
            <div className={`education-card ${classes.educationCard}`}>
                <div className="educard-img" style={{ backgroundColor: theme.primary }}>
                    <img 
                        src={theme.type === 'light' ? eduImgBlack : eduImgWhite} 
                        alt="Education icon" 
                    />
                </div>
                <div className="education-details">
                    <h6 style={{ color: theme.primary }}>{startYear}-{endYear}</h6>
                    <h4 style={{ color: theme.tertiary }}>{course}</h4>
                    <h5 style={{ color: theme.tertiary }}>{institution}</h5>
                </div>
            </div>
        </Fade>        
    );
}

export default EducationCard;